export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";

export const GET_DATA_CATEGORIES = "GET_DATA_CATEGORIES";
export const GET_DATA_CATEGORIES_SUCCESS = "GET_DATA_CATEGORIES_SUCCESS";
export const GET_DATA_CATEGORIES_FAILURE = "GET_DATA_CATEGORIES_FAILURE";

export const CREATE_DATA_CATEGORY = "CREATE_DATA_CATEGORY";
export const CREATE_DATA_CATEGORY_SUCCESS = "CREATE_DATA_CATEGORY_SUCCESS";
export const CREATE_DATA_CATEGORY_FAILURE = "CREATE_DATA_CATEGORY_FAILURE";

export const UPDATE_DATA_CATEGORY = "UPDATE_DATA_CATEGORY";
export const UPDATE_DATA_CATEGORY_SUCCESS = "UPDATE_DATA_CATEGORY_SUCCESS";
export const UPDATE_DATA_CATEGORY_FAILURE = "UPDATE_DATA_CATEGORY_FAILURE";

export const DELETE_DATA_CATEGORY = "DELETE_DATA_CATEGORY";
export const DELETE_DATA_CATEGORY_SUCCESS = "DELETE_DATA_CATEGORY_SUCCESS";
export const DELETE_DATA_CATEGORY_FAILURE = "DELETE_DATA_CATEGORY_FAILURE";

export const UPDATE_DATA_CATEGORY_STATUS = "UPDATE_DATA_CATEGORY_STATUS";
export const UPDATE_DATA_CATEGORY_STATUS_SUCCESS = "UPDATE_DATA_CATEGORY_STATUS_SUCCESS";
export const UPDATE_DATA_CATEGORY_STATUS_FAILURE = "UPDATE_DATA_CATEGORY_STATUS_FAILURE";
